export const getStaticMapUrl = ({
  lat,
  lng,
  zoom = 10,
  accessToken,
  size = '300x280'
}) =>
  `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/${lng},${lat},${zoom},0/${size}?access_token=${accessToken}`;

export const getStaticMapUrlGoogle = ({
  lat,
  lng,
  zoom = 10,
  apiKey,
  size = '300x280'
}) =>
  `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&scale=1&zoom=${zoom}&format=png&maptype=roadmap&size=${size}&key=${apiKey}`;

export default {
  getStaticMapUrl,
  getStaticMapUrlGoogle
};
